import React, {Component} from 'react';
import {Table, Layout} from 'antd';
import {Link} from 'react-router-dom';
import moment from 'moment';
import Head from '../components/Head';
import {api, app} from "../app";
import utils from "../utils";
import '../css/rescue.css';

const {Header, Content} = Layout;

class RescueList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data_loading: true,
            rescuenList: []
        };
        this.dataSource();
    }

    /**
     * 数据源
     */
    dataSource() {
        const _this = this;
        app.post(api.RescueList).then(({flag, data, msg}) => {
            if (flag === 1) {
                _this.setState({rescuenList: utils.addArrayKey(data)});
            } else {
                app.alert("网络服务忙~", "error");
            }
            _this.setState({data_loading: false});
        });
    }

    render() {
        const columns = [
                {
                    title: '救援名称',
                    dataIndex: 'rescuename',
                    key: 'rescuename',
                    width: '35%'
                },
                {
                    title: '救援等级',
                    dataIndex: 'rescuegrade',
                    key: 'rescuegrade',
                    width: '20%'
                },
                {
                    title: '救援进度',
                    dataIndex: '',
                    key: 'jyjd',
                    width: '20%',
                    render: (text, record) => {
                        return (
                            <span>暂无进度记录</span>
                        )
                    }
                },
                {
                    title: '起始时间',
                    dataIndex: '',
                    key: 'ysysj',
                    width: '15%',
                    render: (text, record) => {
                        return (
                            <span>{moment(record.startdate).format("YYYY-MM-DD HH:mm:ss")}</span>
                        )
                    }
                },
                {
                    title: '详情',
                    dataIndex: '',
                    key: 'xq',
                    width: '10%',
                    render: (text, record) => (
                        <span><Link to={"#"} className="table_a">查看详情</Link></span>
                    )
                }
            ], rescuenList = this.state.rescuenList,
            locale = {
                filterTitle: '筛选',
                filterConfirm: '确定',
                filterReset: '重置',
                emptyText: loading ? '正在加载中...' : '暂无数据',
            }, loading = this.state.data_loading;
        return (
            <Layout className="rescue-list">
                <Header style={{height: 'auto', padding: 0}}><Head background="#3F89C1" height={104}
                                                                   history={this.props.history}/></Header>
                <Content className="rl_content">
                    <Table className="table" locale={locale} columns={columns}
                           dataSource={rescuenList} loading={loading}
                           scroll={{ y: 'calc(100% - 63px)' }}
                           title={() => <div className="table_title">救援资讯列表</div>}
                           pagination={{
                               total: rescuenList.length,
                               pageSize: 20,
                               showTotal: (total, range) => `总数: ${total}`
                           }}/>
                </Content>
                {/*<Footer style={{padding: 0}}><Foote/></Footer>*/}
            </Layout>
        );
    }
}

export default RescueList;



// WEBPACK FOOTER //
// ./src/routes/RescueList.jsx